import React from "react";
import { useNavigate } from "react-router-dom";
import image1 from "../images/together-office.jpg"; 
import worker1 from "../images/worker1.jpg";
import worker2 from "../images/worker2.jpg";
import worker3 from "../images/worker3.jpg";
import worker4 from "../images/worker4.jpg";
import worker5 from "../images/worker5.jpg";
import worker6 from "../images/worker6.jpg";
import Footer from "./Footer";

const members = [
  { id: 1, name: "Michele Morrone", role: "Kitchen Cleaner", photo: worker1 },
  { id: 2, name: "Luigi Rossi", role: "Bathroom Cleaner", photo: worker2 },
  { id: 3, name: "Sara Bianchi", role: "Living Room Cleaner", photo: worker3 },
  { id: 4, name: "Marco Verdi", role: "Window Cleaner", photo: worker4 },
  { id: 5, name: "Anna Neri", role: "Garden Cleaner", photo: worker5 },
  { id: 6, name: "Luca Gallo", role: "Floor Cleaner", photo: worker6 },
];

export default function Team() {
  const navigate = useNavigate();

  return (
    <>
      {/* HERO SECTION */}
      <section
        className="contact-hero"
        style={{ backgroundImage: `url(${image1})` }}
      >
        <div className="contact-content">
          <h1 className="hero-title"></h1>
          <nav className="breadcrumb">
            <b>
              <h1 className="fw-bold">Team</h1>
              <a href="/">Home</a>
              <span>›</span>
              <span className="active text-warning">Team</span>
            </b>
          </nav>
        </div>
      </section>

      {/* TEAM GRID */}
      <div className="container py-5">
        <h3 className="text-center mb-4 text-primary"> Workers Team </h3>
        <div className="row g-4">
          {members.map((m) => (
            <div className="col-md-4 col-lg-4" key={m.id}>
              <div
                className="card team-card position-relative"
                onClick={() => navigate(`/member/${m.id}`)}
              >
                <img src={m.photo} className="img-fluid" alt={m.name} />
                <div className="overlay"></div>
                <div className="info-box">
                  <h5>{m.name}</h5>
                  <p>{m.role}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
{/* Cleaning Animations Section */}
<div className="cleaning-wrapper mt-3">

  {/* 1) Wipe Shine Animation */}
  <div className="clean-wipe mb-3">
    Cleaning in Progress...
  </div>

  {/* 2) Broom Sweeping Animation */}
  <div className="broom-area mb-3">
    🧹
  </div>

  {/* 3) Floating Cleaning Bubbles */}
  <div className="bubble-clean mb-3">
    <div className="bubble"></div>
    <div className="bubble"></div>
    <div className="bubble"></div>
  </div>

  {/* 4) Mop Cleaning Loader */}
  <div className="clean-loader mb-3">
    <span className="mop">🧽</span>
    <p>Cleaning...</p>
  </div>

</div>

   
      <Footer />
    </>
  );
}
